import React from "react"

// Authentication
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import UserProfile from "../pages/Authentication/user-profile"

// Landing
import LandingPage from "../pages/LandingPage/index"
import CheckoutPage from "../pages/LandingPage/CheckoutPage"
import CheckoutStatusPage from "../pages/LandingPage/CheckoutStatusPage"
import ReactivatePage from "../pages/LandingPage/ReactivatePage"
import CompetitionRankingPage from "../pages/LandingPage/Competition/CompetitionRankingPage"
import CompetitionCertificateVerifyPage from "../pages/LandingPage/Competition/CompetitionCertificateVerifyPage"

// Platform Admin Global
import PlatformDashboard from "../pages/Platform/Dashboard/index"
import PlatformTenants from "../pages/Platform/Tenants/index"
import PlatformTenantDetail from "../pages/Platform/Tenants/Detail"
import PlatformBilling from "../pages/Platform/Billing/index"
import PlatformPlans from "../pages/Platform/Plans/index"
import PlatformUsers from "../pages/Platform/Users/index"
import PlatformUserDetail from "../pages/Platform/Users/Detail"
import PlatformPermissions from "../pages/Platform/Permissions/index"
import PlatformAudit from "../pages/Platform/Audit/index"
import PlatformSupport from "../pages/Platform/Support/index"
import PlatformMetrics from "../pages/Platform/Metrics/index"
import PlatformOnboarding from "../pages/Platform/Onboarding/index"
import PlatformNotifications from "../pages/Platform/Notifications/index"
import PlatformSettings from "../pages/Platform/Settings/index"
import PlatformMercadoPago from "../pages/Platform/MercadoPago/index"
import PlatformCrm from "../pages/Platform/Crm/index"
import PlatformPortfolio from "../pages/Platform/Portfolio/index"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import ManagerDashboard from "../pages/Dashboard/Manager/index"
import FinancialDashboard from "../pages/Dashboard/Financial/index"

// Admin
import Roles from "../pages/Admin/Roles/index"
import Activities from "../pages/Admin/Activities/index"
import Areas from "../pages/Admin/Areas/index"
import Employees from "../pages/Admin/Employees/index"
import EventsPage from "../pages/Admin/Events/index"
import Levels from "../pages/Admin/Levels/index"
import MembershipsPage from "../pages/Admin/Memberships/index"
import ServicesPage from "../pages/Admin/Services/index"
import BankAccountsPage from "../pages/Admin/BankAccounts/index"
import AcquirersPage from "../pages/Admin/Acquirers/index"
import AuditLogsPage from "../pages/Admin/AuditLogs/index"
import PortfolioPage from "../pages/Admin/Portfolio/index"
import FinancialCategoriesPage from "../pages/Admin/FinancialCategories/index"
// Management
import Classes from "../pages/Management/Classes/index"
import TrialsPage from "../pages/Management/Trials/index"
import PerformancePage from "../pages/Management/Performance/index"
import GoalsPage from "../pages/Management/Goals/index"
import ActivityMembersPage from "../pages/Management/ActivityMembers/index"
import CancellationsPage from "../pages/Management/Cancellations/index"

// Members
import Members from "../pages/Member/index"
import MemberProfile from "../pages/Member/Profile/index"
import DebtPaymentPoint from "../pages/Member/DebtPayment/index"

// Grade
import Grade from "../pages/Grade/index"
import EnrollmentGrade from "../pages/Grade/EnrollmentGrade/index"
import PlanningPage from "../pages/Grade/Planning/index"

// Evaluation
import EvaluationPage from "../pages/Evaluation/index"

// Training
import WorkoutsPage from "../pages/Training/Workouts/index"

// Sales
import SalesPoint from "../pages/Sales/SalesPoint/index"

// CRM
import CrmPage from "../pages/Crm/index"

// Financial
import CashierPage from "../pages/Financial/Cashier/index"
import ReceivablesPage from "../pages/Financial/Receivables/index"
import PayablesPage from "../pages/Financial/Payables/index"
import CashFlowPage from "../pages/Financial/CashFlow/index"
import DREPage from "../pages/Financial/DRE/index"
import SalesPage from "../pages/Financial/Sales/index"

// Settings
import CompanySettingsPage from "../pages/Settings/Company/index"
import GamificationSettingsPage from "../pages/Settings/Gamification/index"
import AutomationsPage from "../pages/Settings/Automations/index"
import IntegrationsPage from "../pages/Settings/Integrations/index"
import ImportMembersPage from "../pages/Settings/ImportMembers/index"
import BusinessRulesPage from "../pages/Settings/BusinessRules/index"
import TenantBillingPage from "../pages/Settings/Billing/index"
import StyleGuidePage from "../pages/Settings/StyleGuide/index"

// Kiosk
import KioskPage from "../pages/Kiosk/index"
import EvaluationSystem from "../pages/Kiosk/EvaluationSystem"
import TVDisplay from "../pages/Kiosk/TVDisplay"
import KioskProfessors from "../pages/Kiosk/Professors"
import PublicTotemLoader from "../pages/Kiosk/PublicTotemLoader"
import WorkoutPrintScreen from "../pages/Kiosk/WorkoutPrintScreen"
import WorkoutDetailsScreen from "../pages/Kiosk/WorkoutDetailsScreen"
import MediaPage from "../pages/Media/index"

// Home
import HomePage from "../pages/Home/index"

// Help Center
import HelpCenter from "../pages/Help/index"
import { PAGE_ACCESS_MAP } from "../constants/access"

const userRoutes = [
  { path: "/home", component: <HomePage /> },
  { path: "/dashboard", component: <Dashboard />, ...PAGE_ACCESS_MAP["/dashboard"] },
  { path: "/dashboard/gerencial", component: <ManagerDashboard />, ...PAGE_ACCESS_MAP["/dashboard/gerencial"] },
  { path: "/dashboard/financeiro", component: <FinancialDashboard />, ...PAGE_ACCESS_MAP["/dashboard/financeiro"] },

  // Admin
  { path: "/admin/roles", component: <Roles />, ...PAGE_ACCESS_MAP["/admin/roles"] },
  { path: "/admin/activities", component: <Activities />, ...PAGE_ACCESS_MAP["/admin/activities"] },
  { path: "/admin/areas", component: <Areas />, permission: "admin_areas" },
  { path: "/admin/employees", component: <Employees />, ...PAGE_ACCESS_MAP["/admin/employees"] },
  { path: "/admin/events", component: <EventsPage />, ...PAGE_ACCESS_MAP["/admin/events"] },
  { path: "/admin/levels", component: <Levels />, ...PAGE_ACCESS_MAP["/admin/levels"] },
  { path: "/admin/memberships", component: <MembershipsPage />, ...PAGE_ACCESS_MAP["/admin/memberships"] },
  { path: "/admin/services", component: <ServicesPage />, ...PAGE_ACCESS_MAP["/admin/services"] },
  { path: "/admin/bank-accounts", component: <BankAccountsPage />, ...PAGE_ACCESS_MAP["/admin/bank-accounts"] },
  { path: "/admin/acquirers", component: <AcquirersPage />, ...PAGE_ACCESS_MAP["/admin/acquirers"] },
  { path: "/admin/audit-logs", component: <AuditLogsPage />, ...PAGE_ACCESS_MAP["/admin/audit-logs"] },
  { path: "/admin/portfolio", component: <PortfolioPage />, ...PAGE_ACCESS_MAP["/admin/portfolio"] },
  { path: "/admin/financial-categories", component: <FinancialCategoriesPage />, ...PAGE_ACCESS_MAP["/admin/financial-categories"] },
  // Management
  { path: "/management/classes", component: <Classes />, ...PAGE_ACCESS_MAP["/management/classes"] },
  { path: "/management/trials", component: <TrialsPage />, ...PAGE_ACCESS_MAP["/management/trials"] },
  { path: "/management/performance", component: <PerformancePage />, ...PAGE_ACCESS_MAP["/management/performance"] },
  { path: "/management/goals", component: <GoalsPage />, ...PAGE_ACCESS_MAP["/management/goals"] },
  { path: "/management/cancellations", component: <CancellationsPage />, ...PAGE_ACCESS_MAP["/management/cancellations"] },
  { path: "/management/activity-members", component: <ActivityMembersPage />, ...PAGE_ACCESS_MAP["/management/activity-members"] },

  // Members
  { path: "/members", component: <Members />, ...PAGE_ACCESS_MAP["/members"] },
  { path: "/members/:id", component: <MemberProfile />, ...PAGE_ACCESS_MAP["/members/:id"] },
  { path: "/members/:id/sales-point", component: <SalesPoint />, ...PAGE_ACCESS_MAP["/members/:id/sales-point"] },
  { path: "/members/:id/debt-payment", component: <DebtPaymentPoint />, ...PAGE_ACCESS_MAP["/members/:id/debt-payment"] },

  // CRM
  { path: "/crm", component: <CrmPage />, ...PAGE_ACCESS_MAP["/crm"] },

  // Grade
  { path: "/grade", component: <Grade />, ...PAGE_ACCESS_MAP["/grade"] },
  { path: "/grade/enrollment", component: <EnrollmentGrade />, ...PAGE_ACCESS_MAP["/grade/enrollment"] },
  { path: "/grade/planning", component: <PlanningPage />, ...PAGE_ACCESS_MAP["/grade/planning"] },

  // Evaluation
  { path: "/evaluation", component: <EvaluationPage />, ...PAGE_ACCESS_MAP["/evaluation"] },

  // Training
  { path: "/training/workouts", component: <WorkoutsPage />, ...PAGE_ACCESS_MAP["/training/workouts"] },

  // Sales
  { path: "/sales", component: <SalesPoint />, ...PAGE_ACCESS_MAP["/sales"] },

  // Financial
  { path: "/financial/cashier", component: <CashierPage />, ...PAGE_ACCESS_MAP["/financial/cashier"] },
  { path: "/financial/receivables", component: <ReceivablesPage />, ...PAGE_ACCESS_MAP["/financial/receivables"] },
  { path: "/financial/payables", component: <PayablesPage />, ...PAGE_ACCESS_MAP["/financial/payables"] },
  { path: "/financial/cash-flow", component: <CashFlowPage />, ...PAGE_ACCESS_MAP["/financial/cash-flow"] },
  { path: "/financial/dre", component: <DREPage />, ...PAGE_ACCESS_MAP["/financial/dre"] },
  { path: "/financial/sales", component: <SalesPage />, ...PAGE_ACCESS_MAP["/financial/sales"] },

  // Settings
  { path: "/settings/company", component: <CompanySettingsPage />, ...PAGE_ACCESS_MAP["/settings/company"] },
  { path: "/settings/gamification", component: <GamificationSettingsPage />, ...PAGE_ACCESS_MAP["/settings/gamification"] },
  { path: "/settings/automations", component: <AutomationsPage />, ...PAGE_ACCESS_MAP["/settings/automations"] },
  { path: "/settings/integrations", component: <IntegrationsPage />, ...PAGE_ACCESS_MAP["/settings/integrations"] },
  { path: "/settings/import-members", component: <ImportMembersPage />, ...PAGE_ACCESS_MAP["/settings/import-members"] },
  { path: "/settings/business-rules", component: <BusinessRulesPage />, ...PAGE_ACCESS_MAP["/settings/business-rules"] },
  { path: "/settings/billing", component: <TenantBillingPage />, permission: "admin_settings" },
  { path: "/settings/styleguide", component: <StyleGuidePage />, ...PAGE_ACCESS_MAP["/settings/company"] },

  // Profile
  { path: "/profile", component: <UserProfile /> },
  
  // Help Center
  { path: "/help", component: <HelpCenter /> },

  // Totem - Mídias (dentro do layout padrão)
  { path: "/kiosk/media", component: <MediaPage />, ...PAGE_ACCESS_MAP["/kiosk/media"] },
]

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/checkout", component: <CheckoutPage /> },
  { path: "/checkout/status", component: <CheckoutStatusPage /> },
  { path: "/reactivate", component: <ReactivatePage /> },
  { path: "/", component: <LandingPage /> },
  { path: "/competicao/ranking", component: <CompetitionRankingPage /> },
  { path: "/competicao/certificado/validar", component: <CompetitionCertificateVerifyPage /> },
  
  // Totem Públicos (Via Magic Link)
  { path: "/totem/tv/:slug", component: <PublicTotemLoader type="tv" /> },
  { path: "/totem/print/:slug", component: <PublicTotemLoader type="print" /> },
  { path: "/totem/auto/:slug", component: <PublicTotemLoader type="auto" /> },
]

const kioskRoutes = [
  { path: "/kiosk", component: <KioskPage />, ...PAGE_ACCESS_MAP["/kiosk"] },
  { path: "/kiosk/evaluation", component: <EvaluationSystem />, ...PAGE_ACCESS_MAP["/kiosk/evaluation"] },
  { path: "/kiosk/tv", component: <TVDisplay />, ...PAGE_ACCESS_MAP["/kiosk/tv"] },
  { path: "/kiosk/print", component: <WorkoutPrintScreen />, ...PAGE_ACCESS_MAP["/kiosk"] },
  { path: "/kiosk/print/details", component: <WorkoutDetailsScreen />, ...PAGE_ACCESS_MAP["/kiosk"] },
  { path: "/kiosk/professors", component: <KioskProfessors />, ...PAGE_ACCESS_MAP["/kiosk/professors"] },
]


const platformRoutes = [
  { path: "/platform",                component: <PlatformDashboard />,    platformPermission: "platform_dashboard"     },
  { path: "/platform/tenants",        component: <PlatformTenants />,      platformPermission: "platform_tenants"       },
  { path: "/platform/tenants/:id",    component: <PlatformTenantDetail />, platformPermission: "platform_tenants"       },
  { path: "/platform/billing",        component: <PlatformBilling />,      platformPermission: "platform_billing"       },
  { path: "/platform/plans",          component: <PlatformPlans />,        platformPermission: "platform_plans"         },
  { path: "/platform/users",          component: <PlatformUsers />,        platformPermission: "platform_users"         },
  { path: "/platform/users/:id",      component: <PlatformUserDetail />,   platformPermission: "platform_users"         },
  { path: "/platform/permissions",    component: <PlatformPermissions />,  platformPermission: "platform_permissions"   },
  { path: "/platform/audit",          component: <PlatformAudit />,        platformPermission: "platform_audit"         },
  { path: "/platform/suporte",        component: <PlatformSupport />,      platformPermission: "platform_support"       },
  { path: "/platform/metricas",       component: <PlatformMetrics />,      platformPermission: "platform_metrics"       },
  { path: "/platform/onboarding",     component: <PlatformOnboarding />,   platformPermission: "platform_onboarding"    },
  { path: "/platform/notificacoes",   component: <PlatformNotifications />,platformPermission: "platform_notifications" },
  { path: "/platform/configuracoes",  component: <PlatformSettings />,     platformPermission: "platform_settings"      },
  { path: "/platform/mercado-pago",   component: <PlatformMercadoPago />,  platformPermission: "platform_mercadopago"   },
  { path: "/platform/crm",            component: <PlatformCrm />,          platformPermission: "platform_crm"           },
  { path: "/platform/portfolio",      component: <PlatformPortfolio />,    platformPermission: "platform_portfolio"     },
]

export { userRoutes, authRoutes, kioskRoutes, platformRoutes }

